import React from 'react';

const Footer = () => {
    return (
        <div className='text-lg font-semibold bg-slate-900 bg-opacity-20 bg-clip-padding backdrop-filter backdrop-blur-sm justify-between py-5 shadow-xl'>
            <p>Happy Coding</p>
            <p>@Copyright - <span className='font-mono font-bold text-transparent text-xl lg:text-4xl bg-clip-text bg-gradient-to-r from-yellow-200 to-purple-300 py-1 mx-4"'>Rahat Ashik</span></p>
        </div>
    );
};

export default Footer;